import { connect } from 'react-redux';
import { currentSubscriptionNextRenewalDateSelector } from '../../../modules/Dashboard';
import {
  nextPlanCharacteristicsSelector,
  nextPlanOptionsSelector,
  nextPlanVouchersSelector,
} from '../../../modules/NextPlan';
import { cancelPlanRequest } from '../../../modules/Subscription/actions';
import NextPlanDetails from './NextPlanDetails';

const mapStateToProps = state => ({
  renewalDate: currentSubscriptionNextRenewalDateSelector(state),
  options: nextPlanOptionsSelector(state),
  planCharacteristics: nextPlanCharacteristicsSelector(state),
  nextPlanVouchers: nextPlanVouchersSelector(state),
});

const mapDispatchToProps = {
  cancelPlanRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(NextPlanDetails);
